<template>
  <div class="login-container">
    <div class="content">
      <VImage :src="require('@/assets/logo-white.png')" class="logo" />
      <div class="btn-wx" @click="loginWechat" v-if="showWx">
        <img :src="require('@/assets/login/wechat.svg')" alt />
        <span>微信登录</span>
      </div>
      <div class="btn-phone" @click="loginPhoneOther">老用户手机号登录</div>
      <div class="btn-register" @click="register">新用户注册</div>
    </div>
  </div>
</template>

<script>
import { getAppId } from "@/api/login";
import { Image as VImage, Toast, Notify } from "vant";
import { isWechat } from "@/utils/auth";
import { mapState, mapActions } from "vuex";
import browserTypeAdapter from "@/utils/browserTypeAdapter";
import { getToken } from "@/utils/auth";

export default {
  components: { VImage },
  data() {
    return {
      customerId: this.$route.query.customerId,
      redirect: undefined,
      otherQuery: {},
      showWx: isWechat(),
      browserTypeStr: null,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.browserTypeStr =
      localStorage.getItem("browserTypeAdapter") || browserTypeAdapter();

    if (this.$route.query.token) {
      console.log("this.$route.query.token");
      this.$store.dispatch("app/showLoading");
      console.log(this.$route.query.token, "setting token end");
      // 在小程序中登录成功之后返回的 token
      const token = this.$route.query.token;
      this.$store.dispatch("user/setLoginInfo", {
        access_token: token,
      });

      this.$store.dispatch("user/setLoginInfo", {
        access_token: token,
      });
      this.$store.dispatch("app/hideLoading");
      console.log(this.$route.query.token, "setting token end");
      this.$router.push({
        path:
          !this.redirect ||
          this.redirect === "undefined" ||
          this.redirect === "null"
            ? "/"
            : this.redirect,
        query: this.otherQuery,
      });
    }

    // else if (this.browserTypeStr === "miniprogram") {
    //   console.log(this.$route.query.autoflag, "this.$route.query.autoflag");
    //   const token = getToken();
    //   // customerId=C6932589358850179073
    //   // 上级分销的 id this.customerId
    //   if (!token && this.autoflag) {
    //     console.log(this.wxjs.miniProgram);
    //     const queryString = this.customerId || "null";
    //     let url;
    //     console.log(this.redirect);
    //     if (
    //       this.redirect &&
    //       this.redirect !== "undefined" &&
    //       this.redirect !== "null"
    //     ) {
    //       url = `../login/login?supId=${queryString}&redirect=${this.redirect}`;
    //     } else {
    //       url = `../login/login?supId=${queryString}`;
    //     }
    //     // wxjs 已经全局注入
    //     this.wxjs.miniProgram.navigateTo({
    //       // 上级 ID
    //       url,
    //       success: function (res) {
    //         console.log("res success 跳转小程序 login 页面成功", res);
    //       },
    //       fail: function (res) {
    //         console.log("res fail 跳转小程序 login 失败", res);
    //       },
    //     });
    //   }
    // }
    // else

    if (this.$route.query.code) {
      console.log(this.$route.query.code, "code");
      this.loginWechatHandle(this.$route.query.code);
    }
  },
  mounted() {
    if (this.showWx) {
      console.log("hello min min 3333");
      this.try_once_login_wechat();
    }
  },
  methods: {
    ...mapActions("app", ["A_UPDATE_WECHAT_LOGIN_FLAG"]),
    try_once_login_wechat() {
      if (this.login_wechat_func_flag) {
        this.A_UPDATE_WECHAT_LOGIN_FLAG(false);
        sessionStorage.setItem("login_wechat_func_flag", false);
        this.loginWechat();
      }
    },
    loginPhoneOther() {
      this.$router.push({
        name: "LoginPhoneOther",
        query: this.$route.query,
      });
    },
    register() {
      if (!this.customerId) {
        Notify({
          message: "请通过他人分享链接或二维码进入",
          type: "danger",
          duration: 3 * 1000,
        });
        return;
      }
      this.$router.push({
        name: "Register",
        query: this.$route.query,
      });
    },
    async loginWechat() {
      console.log("mimin 123 onepisya loginWechat");
      this.$store.dispatch("app/showLoading");
      getAppId()
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.wechatAuth(res.data);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    wechatAuth(appId) {
      const href =
        window.location.origin +
        this.$route.path +
        "?" +
        this.filterCodeByParams();
      const redirect_uri = encodeURIComponent(href);
      // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`; // 弹框拉取授权
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`; // 静默拉取权限
    },
    // 过滤掉 code 参数
    filterCodeByParams() {
      const queryList = [];
      for (const key in this.$route.query) {
        if (Object.hasOwnProperty.call(this.$route.query, key)) {
          if (key !== "code") {
            queryList.push(`${key}=${this.$route.query[key]}`);
          }
        }
      }
      return queryList.join("&");
    },
    // 目前暂时没有使用这个方法，因为在前端暂时没法拿到这个 code ，这个方法是需要在 微信里面使用的
    loginWechatHandle(code) {
      const params = new FormData();
      params.append("code", code);
      params.append("scope", "h5");
      params.append("grant_type", "wx_code");
      this.$store.dispatch("app/showLoading");
      this.$store
        .dispatch("user/loginByWechat", params)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          Toast.success("登录成功");
          this.$router.push({
            path: this.redirect || "/",
            query: this.otherQuery,
          });
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
          console.log("Login fail loginWechatHandle");
          console.log("this.wechatIsExits", this.wechatIsExits);
          this.register();
          // if (this.wechatIsExits === false)
          // {
          //   // 失败我们才去 register
          //   console.log("ready run register")
          //   this.register()
          // }
        });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
  },
  computed: {
    ...mapState({
      login_wechat_func_flag: (state) => state.app.wechat_once_login_flag,
      wechatIsExits: (state) => state.user.wechat_login_status,
    }),
    autoflag() {
      if (this.$route.query.autoflag === "false") {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  height: 100vh;
  width: 100vw;
  background: #c82d26;
  display: flex;
  align-items: center;
  .content {
    width: 100%;
    padding: 0 74px;
  }
  .logo {
    width: 392px;
    margin-bottom: 260px;
  }
  .btn-wx,
  .btn-phone {
    line-height: 82px;
    border-radius: 82px;
    text-align: center;
    font-weight: bold;
    font-size: 26px;
  }
  .btn-wx {
    background: #fff;
    color: #c82d26;
    margin-bottom: 40px;
    img {
      display: inline-block;
      margin-right: 28px;
      width: 38px;
    }
  }
  .btn-phone {
    line-height: 80px;
    color: #fff;
    border: 1px solid #fff;
    box-sizing: border-box;
  }
  .btn-register {
    font-size: 26px;
    font-weight: 500;
    color: #ffffff;
    line-height: 26px;
    margin-top: 40px;
  }
}
</style>
